import { Component, HostListener, OnInit } from '@angular/core';
import { AppUtilService } from 'app/services/app-util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'app/services/authentication.service';
import { switchMap, takeUntil, tap } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'login-suspended',
  templateUrl: './login-suspended.component.html',
  styleUrls: ['./login-suspended.component.scss']
})
export class LoginSuspendedComponent implements OnInit {

  public displayMessage = 'Please contact Customer Service at 1.800.282.7648 for help.';
  public accountStatusDisplay = 'Retrieving the status of your account.';
  public errorMessage: string;
  public isLoading = true;
  private isSuspended = false;
  private unsubscribe$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appUtil: AppUtilService,
    private authService: AuthenticationService
  ) {}

  @HostListener('window:beforeunload', ['$event'])
  public ngOnDestroy(event?): void {
    this.unsubscribe$.next(true);
  }

  public ngOnInit(): void {
    const email = this.route.snapshot.queryParamMap.get('email');
    if (email) {
      this.authService.isWebsiteAccessSuspended(email)
        .pipe(
          tap((isSuspended: boolean) => {
            this.isSuspended = isSuspended;
            if (isSuspended) {
              this.accountStatusDisplay = 'Your account has been Suspended.';
              this.displayMessage = 'We are sorry.  Your account has been suspended.  ' +
                ' Please contact Customer Service at 1.800.282.7648 for help.';
              this.isLoading = false;
            }
          }),
          switchMap(() => this.authService.hasActiveAccounts(email)),
          takeUntil(this.unsubscribe$))
        .subscribe((hasActiveAccounts: boolean) => {
          if (!hasActiveAccounts && !this.isSuspended) {
            this.accountStatusDisplay = 'Your account is unable to login.';
            this.displayMessage = !hasActiveAccounts ? 'We are sorry.  There are no active accounts associated with your login.' +
              ' Please contact Customer Service at 1.800.282.7648 for help.' : this.displayMessage;
            this.isLoading = false;
          }
          else if (!this.isSuspended) {
            this.router.navigate(['login'] );
          }
        }, error => {
          this.errorMessage = error;
        });
    }
    else {
      this.router.navigate(['login'] );
    }
    this.appUtil.setTitle('Log In');
  }
}
